import { WS_URL } from "@/configuration";
import store from "@/store/store";
import Vue from "vue";

class Websocket {
  constructor(eventBus) {
    this.eventBus = eventBus;
    this.connect();
  }
  async connect() {
    const jwt = store.getters["user/jwt"];
    if (!jwt) {
      this.socket = new WebSocket(WS_URL);
    } else {
      this.socket = new WebSocket(WS_URL + "?jwt=" + jwt);
    }

    this.socket.onopen = () => {
      this.connectedStatus = "Connected";
      this.eventBus.$emit("connected");
    };

    this.socket.onmessage = (event) => {
      try {
        const eventData = JSON.parse(event.data);
        if (eventData.messageType == "NOTIFICATION") {
          this.eventBus.$emit("notification", eventData);
        } else if (eventData.messageType == "SYNC") {
          this.eventBus.$emit("sync", eventData);
        } else if (eventData.messageType == "LOGOUT") {
          this.eventBus.$emit("logout", eventData);
        } else if (eventData.messageType == "CONFIG") {
          this.eventBus.$emit("config", eventData);
        } else if (eventData.messageType == "ALERT") {
          this.eventBus.$emit("alert", eventData);
        } else if (eventData.messageType == "TASK_BOARD_UPDATE") {
          this.eventBus.$emit("task-board-update", eventData);
        } else if (eventData.messageType == "ROADMAP_STAGE_UPDATED") {
          this.eventBus.$emit("roadmap-stage-updated", eventData);
        } else if (eventData.messageType == "INVENTORY_INPORT_PROGRESS") {
          this.eventBus.$emit("inventory-import-progress", eventData);
        } else if (eventData.messageType == "INVENTORY_INPORT_JOB_COMPLETED") {
          this.eventBus.$emit("inventory-import-job-completed", eventData);
        }
      } catch {}
    };
  }

  waitForOpenConnection() {
    return new Promise((resolve, reject) => {
      const maxNumberOfAttempts = 10;
      const intervalTime = 200;

      let currentAttempt = 0;
      const interval = setInterval(() => {
        if (currentAttempt > maxNumberOfAttempts - 1) {
          clearInterval(interval);
          reject(new Error("Websocket Connetion: Maximum number of attempts exceeded."));
        } else if (this.socket.readyState === this.socket.OPEN) {
          clearInterval(interval);
          resolve();
        }
        currentAttempt++;
      }, intervalTime);
    });
  }

  // Ex: Client.sendMessage({ foo: "bar" });
  async sendMessage(m) {
    const message = JSON.stringify(m);
    if (this.socket?.readyState !== this.socket?.OPEN) {
      try {
        await this.waitForOpenConnection(this.socket);
        this.socket.send(message);
      } catch (err) {
        console.error(err);
      }
    } else {
      this.socket?.send(message);
    }
  }
}

export const EventBus = new Vue();
export const Client = new Websocket(EventBus);
